import { unparse } from 'papaparse'
import {
  getPapaUnparseItemsData,
  getPapaUnparseAssignmentData,
} from 'utils/functions/misc'

const downloadItems = (items: any[], companyId: string, itemType = 'order') => {
  try {
    let csv
    if (itemType === 'order') {
      csv = unparse(getPapaUnparseAssignmentData(companyId, items))
    } else {
      csv = unparse(getPapaUnparseItemsData(companyId || '', items))
    }
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', items.length > 1 ? 'Items.csv' : 'Item.csv')
    link.click()
  } catch (error) {
    throw new Error(error)
  }
}

export default downloadItems
